import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home.vue'
import ErrorPage from '@/pages/Error.vue'
import About from '@/pages/About.vue'
import Team from '@/pages/Team.vue'
import Practice from '../pages/Practice.vue'
import News from '../pages/News.vue'
import Contact from '../pages/Contact.vue'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    }, {
      path: '*',
      redirect: '/error'
    }, {
      path: '/error',
      name: 'errorPage',
      component: ErrorPage
    }, {
      path: '/home',
      name: 'home',
      component: Home
    }, {
      path: '/about',
      name: 'about',
      component: About
    }, {
      path: '/team',
      name: 'team',
      component: Team
    }, {
      path: '/team/:param',
      name: 'teamDtl',
      component: Team
    }, {
      path: '/practice',
      name: 'practice',
      redirect: '/practice/industries',
      component: Practice
    }, {
      path: '/practice/:pages',
      name: 'practicePages',
      component: Practice
    }, {
      path: '/practice/:pages/:param',
      name: 'practicePagesDtl',
      component: Practice
    }, {
      path: '/news',
      name: 'news',
      component: News
    }, {
      path: '/news/:param',
      name: 'newsDtl',
      component: News
    }, {
      path: '/contact',
      name: 'contact',
      component: Contact
    }
  ]
})



// WEBPACK FOOTER //
// ./src/utils/router.js